import api from "@/lib/api";
import { isIOS, isStandalone, swUrl } from "@/lib/pwa";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const keyBytes = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

/** Ask for permission (when needed), register the service worker and save this browser's subscription. */
export async function enablePush() {
  if (isIOS() && !isStandalone()) throw new Error("On iPhone or iPad, add this app to your Home Screen first, then open it from there");
  if (!pushSupported()) throw new Error("This browser doesn't support pop-up notifications");
  const perm = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Pop-up notifications are blocked for this site in your browser settings");
  const reg = await navigator.serviceWorker.register(swUrl());
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/notifications/push/key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyBytes(data.key) }));
  await api.post("/notifications/push/subscribe", { subscription: sub.toJSON() });
}

export async function disablePush() {
  const reg = pushSupported() && (await navigator.serviceWorker.getRegistration("/sw.js"));
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub) return;
  await api.post("/notifications/push/unsubscribe", { subscription: sub.toJSON() }).catch(() => {});
  await sub.unsubscribe();
}

export async function pushEnabled() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  return !!(reg && (await reg.pushManager.getSubscription()));
}
